import { render, staticRenderFns } from "./AIProjectMentionsView.vue?vue&type=template&id=04df3b9b&"
import script from "./AIProjectMentionsView.vue?vue&type=script&lang=js&"
export * from "./AIProjectMentionsView.vue?vue&type=script&lang=js&"
import style0 from "./AIProjectMentionsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VTooltip})
